import { gql } from "@apollo/client";

export type MarkVenuePortalUserNotificationsReadInput = {
  venuePortalUserId: string;
};

export type MarkVenuePortalUserNotificationsReadResponse = {
  markVenuePortalUserNotificationsRead: boolean;
};

export const MARK_VENUE_PORTAL_USER_NOTIFICATIONS_READ_MUTATION = gql`
  mutation MarkVenuePortalUserNotificationsRead($venuePortalUserId: ID!) {
    markVenuePortalUserNotificationsRead(venuePortalUserId: $venuePortalUserId)
  }
`;
